// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* :host instead of :root since we're working inside shadow dom */
:host {
    --spacing: min(0.3vw, 6px);

    --gig-padding: 1vw;

    --primary: rgb(255, 225, 225);
    --primary-light: rgb(255, 235, 235);
    --primary-dark: rgb(255, 215, 215);
    --gig-spacing: 0.5vw;

    --button-color-primary: rgb(100,120,200);
    --button-color-primary-hover: rgba(100,120,200, 5%);
    --button-color-success: rgb(0,180,0);
    --button-color-success-hover: rgba(0,180,0, 5%);
    --button-color-danger: rgb(200,20,0);
    --button-color-danger-hover: rgba(200,20,0, 5%);
    --button-color-secondary: rgb(180,20,0);
    --button-color-secondary-hover: rgba(180,20,0, 5%);

    --button-color-primary-alpha: rgba(100,120,200, 20%);
    --button-color-success-alpha: rgba(0,180,0, 20%);
    --button-color-danger-alpha: rgba(200,20,0, 20%);
}

a {
    text-decoration: none;
    color: royalblue;
}

b {
    font-weight: bolder;
}

h6 {
    margin-block-start: 15px;
    margin-block-end: 5px;
    font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/css/theme.css"],"names":[],"mappings":"AAAA,iEAAiE;AACjE;IACI,0BAA0B;;IAE1B,kBAAkB;;IAElB,6BAA6B;IAC7B,mCAAmC;IACnC,kCAAkC;IAClC,oBAAoB;;IAEpB,wCAAwC;IACxC,mDAAmD;IACnD,oCAAoC;IACpC,+CAA+C;IAC/C,oCAAoC;IACpC,+CAA+C;IAC/C,uCAAuC;IACvC,kDAAkD;;IAElD,oDAAoD;IACpD,gDAAgD;IAChD,gDAAgD;AACpD;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,eAAe;AACnB","sourcesContent":["/* :host instead of :root since we're working inside shadow dom */\n:host {\n    --spacing: min(0.3vw, 6px);\n\n    --gig-padding: 1vw;\n\n    --primary: rgb(255, 225, 225);\n    --primary-light: rgb(255, 235, 235);\n    --primary-dark: rgb(255, 215, 215);\n    --gig-spacing: 0.5vw;\n\n    --button-color-primary: rgb(100,120,200);\n    --button-color-primary-hover: rgba(100,120,200, 5%);\n    --button-color-success: rgb(0,180,0);\n    --button-color-success-hover: rgba(0,180,0, 5%);\n    --button-color-danger: rgb(200,20,0);\n    --button-color-danger-hover: rgba(200,20,0, 5%);\n    --button-color-secondary: rgb(180,20,0);\n    --button-color-secondary-hover: rgba(180,20,0, 5%);\n\n    --button-color-primary-alpha: rgba(100,120,200, 20%);\n    --button-color-success-alpha: rgba(0,180,0, 20%);\n    --button-color-danger-alpha: rgba(200,20,0, 20%);\n}\n\na {\n    text-decoration: none;\n    color: royalblue;\n}\n\nb {\n    font-weight: bolder;\n}\n\nh6 {\n    margin-block-start: 15px;\n    margin-block-end: 5px;\n    font-size: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
